/* Embed (iframe) view detection and per-client display config.
 *
 * Before this existed the check `window.parent !== window.self` was written out
 * inline in five separate components; use these helpers instead so the flags are
 * read the same way everywhere.
 *
 * Flags travel as short codes inside the encrypted session blob (`ifc`) because
 * the RSA payload has only ~70 bytes of headroom — see external/api-token.
 */

export const IFRAME_FLAGS = {
  TEAM_BOOKINGS: 'team',
  ACTIVITY: 'activity',
  EARNINGS: 'earnings',
  PAYMENT_LINK: 'paymentLink',
}

export const isIframeView = () => window.parent !== window.self

/* Flags only apply inside the embed: the full app is never reduced by them. */
export const iframeFlags = auth => {
  if (!isIframeView()) return []
  const flags = auth && auth.ifc
  return Array.isArray(flags) ? flags : []
}

export const isIframeFlagSet = (auth, flag) =>
  iframeFlags(auth).indexOf(flag) !== -1

/* Client-supplied flags may only ever hide more than the API key allows, never
 * reveal something the key's config hides. */
export const mergeIframeFlags = (serverFlags, clientFlags) => {
  const safe = Array.isArray(serverFlags) ? serverFlags.slice() : []
  if (!Array.isArray(clientFlags)) return safe
  const allowed = Object.keys(IFRAME_FLAGS).map(k => IFRAME_FLAGS[k])
  clientFlags.forEach(f => {
    if (allowed.indexOf(f) !== -1 && safe.indexOf(f) === -1) safe.push(f)
  })
  return safe
}
